import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { AppState } from '@app/reducers';
import { ResponseMessageTypes } from '@app/shared/enums';
import { HttpCancelService, OtherService, RxjsService, SnackbarService } from '@app/shared/services';
import { dealerCustomerServiceAgreementDataState$ } from '@modules/dealer/components/dealer-contract/dealer-agreement-summary/dealer-customer-creation-service-agreement-ngrx-files/dealer-customer-creation-service-agreement.selectors';
import { DealerCustomerServiceAgreementParamsDataModel } from '@modules/dealer/models/dealer-service-agreement.model';
import { selectLeadCreationStepperParamsState$ } from '@modules/sales/components/task-management/lead-creation-ngrx-files/lead-creation.selectors';
import { ServiceAgreementStepsParams } from '@modules/sales/models/lead-creation-stepper.model';
import { Store } from '@ngrx/store';
import { combineLatest, fromEvent, Subject } from 'rxjs';
import { shareReplay, takeUntil, tap } from 'rxjs/operators';
/* this directive will get a control only whichever the form tag is having with the attribute "customForm" and
 and form submission button must have a type as "submit"
*/
@Directive({
  selector: 'form[customForm]'
})

export class FormSubmitDirective {
  isFormChangeDetected = false;
  dealerCustomerServiceAgreementParamsDataModel: DealerCustomerServiceAgreementParamsDataModel;
  serviceAgreementStepsParams: ServiceAgreementStepsParams;
  private readonly completed$ = new Subject();

  // consider the submit as an observable event and add your logics here during the form submission whatever logics needs to be added here 
  submitted$ = fromEvent(this.element, 'submit')
    .pipe(takeUntil(this.completed$), tap(() => {
      if (this.otherService?.currentUrl?.includes('dealer/dealer-contract/service-agreement')) {
        this.combineLatestNgrxStoreDataForDealerServiceAgreement();
      }
      else if (this.otherService?.currentUrl?.includes('my-leads/service-agreement') ||
        this.otherService?.currentUrl?.includes('leads/service-agreement')) {
        this.combineLatestNgrxStoreDataForLeadServiceAgreement();
      }
      setTimeout(() => {
        // find invalid form control and focus on that control 
        const nativeInvalidControl = this.elementRef.nativeElement.querySelector('.is-invalid') as HTMLElement;
        if (nativeInvalidControl && !nativeInvalidControl.className.includes('disabled') && !nativeInvalidControl['disabled']) {
          nativeInvalidControl.focus();
        }
      });
      // show popup on submitted form has an undeitable values
      const classNames = this.element.className.split(' ');
      // this line is do manual form field changes are marked as changed even though the fields are not really changed
      this.rxjsService.getFormChangeDetectionProperty().subscribe((isFormChangeDetected: boolean) => {
        this.isFormChangeDetected = isFormChangeDetected;
      });
      // to make sure that backend request is prevented whenever the form is unchanged (none of the field has changed its previous value) and trying to submit
      const areFormClassNamesNotIncluded = this.isFormChangeDetected ? false :
        (!classNames.includes("ng-dirty") || classNames.includes("ng-pristine") || classNames.includes("ng-untouched"));
      const areClassNamesListOneNotIncluded = classNames.includes("ng-valid");
      if (areFormClassNamesNotIncluded && areClassNamesListOneNotIncluded) {
        // this line is responsible to cancel the on going request while trying to submit the unchanged form
        this.httpCancelService.cancelPendingRequestsOnFormSubmission();
        this.rxjsService.setGlobalLoaderProperty(false);
        this.rxjsService.setPopupLoaderProperty(false);
        this.snackbarService.openSnackbar("No Changes were detected", ResponseMessageTypes.WARNING);
      }
      // add a submitted class on click on the submit button (only based on the button type as "submit")
      if (this.element.classList.contains('submitted') === false) {
        this.renderer.addClass(this.elementRef.nativeElement, 'submitted');
      }
      this.rxjsService.setFormChangeDetectionProperty(false);
    }), shareReplay(1))
  // on every reset button click it will trigger
  reset$ = fromEvent(this.element, 'reset').pipe(takeUntil(this.completed$), tap(() => {
  }), shareReplay(1));


  constructor(public elementRef: ElementRef<HTMLFormElement>, private renderer: Renderer2,
    private httpCancelService: HttpCancelService, private rxjsService: RxjsService,
    private snackbarService: SnackbarService, private store: Store<AppState>, private otherService: OtherService) {
  }

  /* when the user tries to copy the existing details from the service / installation agreement at the time of capture 
button click then even without making changes the user can be able to save the form */
  combineLatestNgrxStoreDataForDealerServiceAgreement() {
    combineLatest([
      this.store.select(dealerCustomerServiceAgreementDataState$)]
    ).subscribe((response) => {
      if (!response) return;
      this.dealerCustomerServiceAgreementParamsDataModel = new DealerCustomerServiceAgreementParamsDataModel(response[0]);
      if (this.dealerCustomerServiceAgreementParamsDataModel.isExist) {
        this.rxjsService.setFormChangeDetectionProperty(true);
      }
    });
  }

  /* when the user tries to copy the existing details from the service / installation agreement at the time of capture 
  button click then even without making changes the user can be able to save the form */
  combineLatestNgrxStoreDataForLeadServiceAgreement() {
    combineLatest([
      this.store.select(selectLeadCreationStepperParamsState$)]
    ).subscribe((response) => {
      if (!response) return;
      this.serviceAgreementStepsParams = new ServiceAgreementStepsParams(response[0]);
      if (this.serviceAgreementStepsParams.isExist) {
        this.rxjsService.setFormChangeDetectionProperty(true);
      }
    });
  }

  get element() {
    return this.elementRef.nativeElement;
  }

  // returns the element's localname such as input,select,input-custom-control,select-custom-control etc...
  get nativeElementLocalName() {
    return this.elementRef.nativeElement.localName;
  }

  ngOnDestroy() {
    this.completed$.next(null);
    this.completed$.complete();
  }
}
